import { cn } from '../lib/cn';
import { activityDotColor, relativeTime } from '../lib/relativeTime';

const DOT_COLORS: Record<ReturnType<typeof activityDotColor>, string> = {
  green: 'bg-status-ok',
  amber: 'bg-status-warn',
  red: 'bg-status-err',
  grey: 'bg-ink-3',
};

/**
 * "4d" / "I dag" / "I går" / "2u" etc. with a leading dot coloured by
 * recency (spec Appendix E). Used in D.1 / D.2 Sidst aktiv column.
 */
export function RelativeTime({
  value,
  showDot = true,
  className,
  titleFallback,
}: {
  value: Date | string | null | undefined;
  showDot?: boolean;
  className?: string;
  /** HTML title= for hover; defaults to ISO datetime. */
  titleFallback?: string;
}) {
  const label = relativeTime(value);
  const dot = activityDotColor(value);
  const title =
    titleFallback ??
    (value instanceof Date ? value.toISOString() : typeof value === 'string' ? value : undefined);

  return (
    <span className={cn('inline-flex items-center gap-1.5 text-ui', className)} title={title}>
      {showDot ? (
        <span className={cn('h-2 w-2 shrink-0 rounded-token-pill', DOT_COLORS[dot])} />
      ) : null}
      <span className="text-ink-1">{label}</span>
    </span>
  );
}
